/**
 * External imports
 */
import 'jquery'
import 'angular'
import 'angular-route'
import 'bootstrap-sass'

/**
 * Styles
 */
import './style/widgetSitePicker.scss'

/**
 * "config" module
 */
import '../components/config/app'
import '../components/config/tgConfig-factory'

/**
 * "widgetSitePicker" module
 */
import './app'
import './controllers/twMainCtrl'
